<section class="error">
<h3>Something went wrong</h3>
<p>We're unable to complete your request. Please call 877.996.7017, Monday through Friday, 7 a.m. - 8 p.m. ET.</p>
<p>When prompted for a PIN, use this error code: XXXX </p>
<p class="lg-hide">

<a href="#" (click)="backToPreviousPage()" class="lg-hide">Back to {{ link }} page</a><br>
<a class="home"href="/businessconsole/home">AT&T Business Console</a>
</p>
</section>